export default [
  {
    value: 'displayName',
    text: 'Отображаемое имя',
    type: 'string',
    description: ''
  },
  {
    value: 'type',
    text: 'Тип',
    type: 'string',
    description: ''
  },
  {
    value: 'name',
    text: 'Имя',
    type: 'string',
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 160,
    type: 'actions',
    sortable: false,
    align: 'end',
    description: ''
  }
]
